
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const BlogPage = () => {
  const blogPosts = [
    {
      title: 'Yangın Tüpü Dolumu Ne Zaman Yapılır?',
      excerpt: 'Yangın tüpü dolumu, yangın güvenliğiniz için kritik öneme sahiptir. Bu yazımızda yangın tüpü dolum periyotları, dolum işleminin nasıl yapıldığı ve neden önemli olduğunu detaylı şekilde anlatıyoruz.',
      category: 'Yangın Tüpü Bakımı',
      date: '15 Aralık 2024',
      image: 'https://public.readdy.ai/ai/img_res/e8b99b525e10ed7223eb8937515aaffc.jpg',
      keywords: 'yangın tüpü dolumu, yangın tüpü dolum periyodu',
    },
    {
      title: 'Baca Temizliği Neden Önemlidir? (Ev ve İşletme)',
      excerpt: 'Baca temizliği, hem ev hem de işletmeler için hayati önem taşır. Kirli bacalar yangın riskini artırır ve zehirli gaz birikimine neden olur. Düzenli baca temizliğinin faydalarını öğrenin.',
      category: 'Baca Temizliği',
      date: '10 Aralık 2024',
      image: 'https://readdy.ai/api/search-image?query=professional%20chimney%20sweep%20worker%20cleaning%20residential%20chimney%20on%20roof%20with%20modern%20equipment%20clean%20white%20house%20background%20safety%20focused%20bright%20daylight&width=600&height=400&seq=blog2&orientation=landscape',
      keywords: 'baca temizliği, baca temizliği önemi',
    },
    {
      title: 'Davlumbaz Temizliği ve Yangın Riskleri',
      excerpt: 'Restoran ve endüstriyel mutfaklarda davlumbaz temizliği ihmal edildiğinde ciddi yangın riskleri ortaya çıkar. Davlumbaz ve kanal temizliğinin ne kadar önemli olduğunu ve nasıl yapılması gerektiğini anlatıyoruz.',
      category: 'Davlumbaz Temizliği',
      date: '5 Aralık 2024',
      image: 'https://readdy.ai/api/search-image?query=commercial%20kitchen%20hood%20cleaning%20service%20in%20modern%20restaurant%20with%20stainless%20steel%20equipment%20professional%20cleaning%20crew%20clean%20white%20walls%20industrial%20maintenance&width=600&height=400&seq=blog3&orientation=landscape',
      keywords: 'davlumbaz temizliği, davlumbaz kanal temizliği',
    },
    {
      title: 'Otomatik Davlumbaz Söndürme Sistemi Nedir?',
      excerpt: 'Mutfak yangınlarına karşı en etkili koruma yöntemi olan otomatik davlumbaz söndürme sistemlerini detaylı şekilde inceliyoruz. Sistem nasıl çalışır, kimler için gereklidir ve bakımı nasıl yapılır?',
      category: 'Yangın Söndürme Sistemleri',
      date: '1 Aralık 2024',
      image: 'https://readdy.ai/api/search-image?query=automatic%20kitchen%20fire%20suppression%20system%20installed%20above%20commercial%20cooking%20equipment%20in%20modern%20restaurant%20kitchen%20clean%20white%20environment%20professional%20safety%20installation&width=600&height=400&seq=blog4&orientation=landscape',
      keywords: 'otomatik davlumbaz söndürme sistemi, mutfak yangın söndürme sistemi',
    },
    {
      title: 'Yangın Tüpü Bakımı: Periyodik Kontrol Rehberi',
      excerpt: 'Yangın tüpü bakım ve periyodik kontrol işlemleri nasıl yapılır? Hangi kontroller yapılmalı, ne sıklıkla bakım gerekir? Yangın tüpü bakımı hakkında bilmeniz gereken her şey bu yazıda.',
      category: 'Yangın Tüpü Bakımı',
      date: '25 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20inspecting%20fire%20extinguisher%20with%20checklist%20and%20tools%20in%20clean%20white%20service%20center%20safety%20inspection%20quality%20control%20bright%20professional%20environment&width=600&height=400&seq=blog5&orientation=landscape',
      keywords: 'yangın tüpü bakım, yangın tüpü kontrol',
    },
    {
      title: 'Yangın Söndürme Tüpü Seçim Rehberi',
      excerpt: 'Hangi yangın tüpünü seçmelisiniz? ABC tozlu, köpüklü, CO₂ veya su bazlı? Her tüp tipinin kullanım alanları, avantajları ve dezavantajlarını detaylı şekilde anlatıyoruz.',
      category: 'Yangın Tüpü Satış',
      date: '20 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=variety%20of%20different%20types%20red%20fire%20extinguishers%20displayed%20in%20professional%20showroom%20with%20clean%20white%20background%20modern%20safety%20equipment%20store%20bright%20organized%20display&width=600&height=400&seq=blog6&orientation=landscape',
      keywords: 'yangın söndürme tüpü, yangın tüpü satış',
    },
    {
      title: 'Baca Temizliği Fiyatları ve Hizmet Süreci',
      excerpt: 'Baca temizliği fiyatları neye göre değişir? Hizmet süreci nasıl işler? Baca temizliği yaptırırken nelere dikkat etmelisiniz? Tüm sorularınızın cevabı bu yazıda.',
      category: 'Baca Temizliği',
      date: '15 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=professional%20chimney%20cleaning%20service%20worker%20with%20equipment%20on%20residential%20roof%20clean%20white%20house%20background%20safety%20gear%20bright%20daylight%20professional%20service&width=600&height=400&seq=blog7&orientation=landscape',
      keywords: 'baca temizliği fiyatları, baca temizliği hizmeti',
    },
    {
      title: 'Restoran Yangın Güvenliği: Kapsamlı Rehber',
      excerpt: 'Restoranlar için yangın güvenliği önlemleri nelerdir? Davlumbaz temizliği, yangın tüpleri, otomatik söndürme sistemleri ve daha fazlası. Restoran sahipleri için kapsamlı yangın güvenliği rehberi.',
      category: 'Yangın Güvenliği',
      date: '10 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20restaurant%20kitchen%20with%20fire%20safety%20equipment%20clean%20stainless%20steel%20surfaces%20professional%20cooking%20area%20bright%20lighting%20safety%20focused&width=600&height=400&seq=blog8&orientation=landscape',
      keywords: 'restoran yangın güvenliği, davlumbaz temizliği',
    },
    {
      title: 'Yangın Söndürme Ekipmanları: Tam Liste',
      excerpt: 'Bir işletmede bulunması gereken yangın söndürme ekipmanları nelerdir? Yangın dolapları, hortumlar, uyarı levhaları ve diğer tüm ekipmanları detaylı şekilde inceliyoruz.',
      category: 'Yangın Ekipmanları',
      date: '5 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=fire%20safety%20equipment%20display%20including%20fire%20hose%20cabinet%20signs%20and%20accessories%20in%20modern%20clean%20white%20showroom%20professional%20safety%20products%20organized%20presentation&width=600&height=400&seq=blog9&orientation=landscape',
      keywords: 'yangın söndürme ekipmanları, yangın güvenlik malzemeleri',
    },
    {
      title: 'Davlumbaz Söndürme Sistemi Bakımı Nasıl Yapılır?',
      excerpt: 'Otomatik davlumbaz söndürme sistemlerinin düzenli bakımı hayati önem taşır. Bakım periyotları, kontrol edilmesi gerekenler ve bakım sürecini detaylı şekilde anlatıyoruz.',
      category: 'Sistem Bakımı',
      date: '1 Kasım 2024',
      image: 'https://readdy.ai/api/search-image?query=technician%20performing%20maintenance%20on%20automatic%20kitchen%20fire%20suppression%20system%20in%20commercial%20kitchen%20professional%20service%20clean%20environment%20bright%20lighting&width=600&height=400&seq=blog10&orientation=landscape',
      keywords: 'davlumbaz söndürme sistemi bakımı, otomatik söndürme sistemi',
    },
  ];

  const categories = [
    'Tümü',
    'Yangın Tüpü Bakımı',
    'Baca Temizliği',
    'Davlumbaz Temizliği',
    'Yangın Söndürme Sistemleri',
    'Yangın Güvenliği',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Blog
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği hakkında bilmeniz gereken her şey
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 bg-white border-b border-dark-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap ${
                  index === 0
                    ? 'bg-primary-600 text-white'
                    : 'bg-dark-100 text-dark-700 hover:bg-primary-100 hover:text-primary-600'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <article
                key={index}
                className="bg-white border-2 border-dark-100 rounded-xl overflow-hidden hover:border-primary-500 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-full h-56 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full whitespace-nowrap">
                      {post.category}
                    </span>
                    <span className="text-xs text-dark-500 whitespace-nowrap">{post.date}</span>
                  </div>
                  <h2 className="font-display font-semibold text-xl text-dark-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-dark-600 text-sm mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center text-primary-600 font-semibold text-sm group-hover:translate-x-2 transition-transform whitespace-nowrap">
                    <span>Devamını Oku</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-dark-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl text-white mb-4">
            Blog Güncellemelerini Kaçırmayın
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Yangın güvenliği hakkında en güncel bilgileri e-posta ile alın
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="E-posta adresiniz"
              className="flex-1 px-6 py-4 rounded-lg text-dark-900 focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
            <button
              type="submit"
              className="bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap"
            >
              Abone Ol
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
